import { Component, OnInit, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { LANGUAGE_MAPPINGS } from '../../../common/constants/language-mappings.const';
import { MyAccountService } from '../../../core/routing/services/my-account/my-account.service';
import { Subject } from 'rxjs/internal/Subject';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { SelectLanguageConstants } from '../../../common/components/select-lang/constants/select-lang.consts';
import { Utils } from '../../../common/utils/utils';
import { GlobalConstants } from '../../../common/constants/global.constant';
import { CommonService } from '../../../common/services/common.service';
import { GoogleAnalyticsService } from '../../google-analytics/google-analytics.service';

@Component({
  selector: 'iposcen-change-language',
  templateUrl: './change-language.component.html',
  styleUrls: ['./change-language.component.scss']
})
export class ChangeLanguageComponent implements OnInit, OnDestroy {
  @ViewChild('searchValue') animateThis: ElementRef;
  languageJSON = [] as any;
  hasData: boolean;
  langForm: FormGroup;
  selectedLanguageName: string;
  selectedLanguageCode: string;
  isLanguageChanged: boolean;
  searchData: string;
  searchClose: boolean;
  languageHeading = SelectLanguageConstants.LANGUAGE_HEADING;
  languageDescription = SelectLanguageConstants.LANGUAGE_SUB_HEADING_DESC;
  selectLanguageLabel = SelectLanguageConstants.SELECT_LANGUAGE;
  searchLanguageLabel = SelectLanguageConstants.SEARCH_LANGUAGE;
  routeLink: string;
  isDisabled: boolean;
  preferredLanguage: string;
  noRecord = GlobalConstants.NO_RECORDS_FOUND;
  isLoading = true;
  globConst = GlobalConstants;
  showRetailGif = false;
  isVietnamese = localStorage.getItem('preferredLanguage') === 'vi' || localStorage.getItem('preferredLanguage') === 'tr';
  private ngUnsubscribe = new Subject<boolean>();

  constructor(private formbuilder: FormBuilder,
    private myAccountService: MyAccountService,
    private cmnService: CommonService,
    private googleAnalyticsService: GoogleAnalyticsService) { }

  ngOnInit(): void {
    this.searchClose = false;
    this.isDisabled = true;
    this.getUserLanguageDetails();
    this.langForm = this.formbuilder.group({
      lang: new FormControl('', [Validators.required])
    });
    this.cmnService.getRetailGifValue
    .pipe(takeUntil(this.ngUnsubscribe))
    .subscribe(data => {
      if(data) {
        this.showRetailGif = true;
      }
    });
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  getUserLanguageDetails() {
    this.myAccountService.getUserAccountDetails()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(userDetails => {
        this.preferredLanguage = userDetails.user.language;
        this.selectedLanguageCode = userDetails.user.language;
        this.loadJSONObject(this.preferredLanguage);
        this.cmnService.setRetailGifValue(false);
      },
        error => {
          Utils.handleError(error, this.constructor.name);
        });
  }

  trackByLanguage(index: number, el: string): number {
    return index;
  }

  loadJSONObject(defaultLanguage: string): void {
    LANGUAGE_MAPPINGS.forEach(element => {
      let display = false;
      if (defaultLanguage === element.langCode) {
        display = true;
      }
      const language = {
        langCode: element.langCode,
        langName: element.langName,
        langInEng: element.langInEng,
        checked: display
      };
      this.languageJSON.push(language);
      this.hasData = this.languageJSON.length > 0 ? true : false;
    });
  }

  selectLanguage(selectedLangName: string, selectedLangCode: string) {
    this.isDisabled = (this.preferredLanguage === selectedLangName) ? true : false;
    this.selectedLanguageName = selectedLangName;
    this.selectedLanguageCode = selectedLangCode;
  }

  changeLanguage() {
    const inputParams = {
      language: this.selectedLanguageCode
    };
    this.myAccountService.updateAccountDetail(inputParams)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(userResponse => {
        if (userResponse) {
          this.isLanguageChanged = true;
          if (this.selectedLanguageCode === 'zh-tw') {
            this.selectedLanguageCode = 'zh-Hant'
          } else if (this.selectedLanguageCode === 'zh-cn') {
            this.selectedLanguageCode = 'zh-Hans'
          }
        }
        this.googleAnalyticsService.accountLanguage(this.selectedLanguageName)
      },
        error => {
          Utils.handleError(error, this.constructor.name);
        });
  }

  closeModal() {
    this.isLanguageChanged = false;
    // reloading page with changed language code
    localStorage.setItem('preferredLanguage', this.selectedLanguageCode);
    localStorage.setItem('preferredLanguageName', this.selectedLanguageName);
    this.routeLink = `/${this.selectedLanguageCode}/change-language`;
    location.assign(this.routeLink);
  }

  searchLanguageOnEnter(searchData) {
    this.animateThis.nativeElement.blur();
    if (!searchData) {
      this.searchClose = false;
    }
    if (searchData) {
      this.searchClose = true;
      const result = this.languageJSON.filter(ele => ele.langInEng.toLowerCase()
        .includes(searchData.toLowerCase()));
      this.languageJSON = result;
      this.hasData = this.languageJSON.length > 0 ? true : false;
    }
  }

  clearSearch() {
    this.searchClose = false;
    this.animateThis.nativeElement.value = '';
    this.searchData = '';
    this.languageJSON = [];
    this.loadJSONObject(this.selectedLanguageCode);
  }
}
